export const convertToHumanReadableDate = (date) => {
	const newLastUpdateDate = new Date(date);
	const toReturn = newLastUpdateDate.toLocaleDateString();
	return toReturn;
};
